import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { axiosClient } from '../../../core/axios-client'
import { FleetFilters } from '../../../core/constants'

async function fetchAllPages(url, { filters = {}, signal } = {}) {
  const all = [];
  let page = 1;

  while (true) {
    if (signal?.aborted) {
      throw new Error('aborted');
    }

    const response = await axiosClient.get(url, {
      params: { ...filters, page },
      signal,
    });

    const data = response.data;
    if (Array.isArray(data.results) && data.results.length) {
      all.push(...data.results);
    }

    if (!data.next) break;

    page += 1;
  }

  return all;
}

const fetchMapUnits = createAsyncThunk(
    'fetchMapUnits',
    async ({ filters } = {}, thunkAPI) => {
      return await fetchAllPages('/bikes/', { filters, signal: thunkAPI.signal });
    }
)

const fetchMapDrawerUnits = createAsyncThunk(
    'fetchMapDrawerUnits',
    async ({ filters } = {}, thunkAPI) => {
      return await fetchAllPages('/bikes/', { filters, signal: thunkAPI.signal });
    }
)

const fetchClientHubs = createAsyncThunk(
    'fetchClientHubs',
    async () => {
      const response = await axiosClient.get('/client-hubs/');
      return response.data.results;
    }
);


const fetchMapUnitsCounts = createAsyncThunk(
  'fetchUnitsCounts',
  async () => {

    const statusCount = await axiosClient.get('/bikes/count/status/');

    const subscriptionCount = await axiosClient.get('/bikes/count/subscription/');

    return {
      status: statusCount.data,
      subscription_type: subscriptionCount.data,
  }
})

const initialState = {
  filterBy: 'status',
  // Поиск по номеру, раме, серийнику, госномеру и IMEI
  search: '',
  filters: FleetFilters['status'],
  selectedFilters: [],
  drawnerOpen: true,
  drawerItems: [],
  mapItems: [],
  clientHubs: [],
  counts: {
    status: null,
    subscription_type: null
  },
}

export const slice = createSlice({
  name: 'fleet-map',

  initialState,

  reducers: {
    setMapSearch(state, { payload }) {
      state.search = payload
    },
    setMapFilterBy(state, { payload }) {
      state.filterBy = payload
      state.selectedFilters = []
      state.filters = FleetFilters[payload]
    },
    setMapSelectedFilters(state, { payload }){
      if(state.selectedFilters.includes(payload)){
        state.selectedFilters = state.selectedFilters.filter(filter => filter !== payload)
      } else {
        state.selectedFilters.push(payload)
      } 
    },
    setDrawner(state, { payload }){
      state.drawnerOpen = payload
    },
    resetMapSelectedFilters(state){
      state.selectedFilters = []
    },
    updateMapsUnits(state, { payload }){
      state.mapItems = state.mapItems.map(item => {
        let proxyItem = {...item}
        const soketItem = payload.find(payloadItem => payloadItem.id === item.id)
        if(soketItem){
          proxyItem = {
            ...proxyItem,
            ...soketItem
          }
        }
        return proxyItem
      })
      
      state.drawerItems = state.drawerItems.map(item => {
        let proxyItem = {...item}
        const soketItem = payload.find(payloadItem => payloadItem.id === item.id)
        if(soketItem){
          proxyItem = {
            ...proxyItem,
            ...soketItem
          }
        }
        return proxyItem
      })
    },
    updateMapLocations(state, { payload }) {
      state.mapItems = state.mapItems.map(item => {
        const updated = payload.find(p => p.id === item.id)
        if (updated && updated.location) {
          return { ...item, location: updated.location }
        }
        return item
      })
      state.drawerItems = state.drawerItems.map(item => {
        const updated = payload.find(p => p.id === item.id)
        if (updated && updated.location) {
          return { ...item, location: updated.location }
        }
        return item
      })
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchMapUnits.fulfilled, (state, { payload }) => {
      state.mapItems = payload.filter(bike => bike?.location?.lat && bike?.location?.lon);
    })

    builder.addCase(fetchMapDrawerUnits.fulfilled, (state, { payload }) => {
      state.drawerItems = payload;
    })

    builder.addCase(fetchClientHubs.fulfilled, (state, { payload }) => {
      state.clientHubs = payload
          .filter(hub => hub.location?.lat && hub.location?.lon)
          .map(hub => ({
            ...hub,
            location: {
              lat: parseFloat(hub.location.lat),
              lon: parseFloat(hub.location.lon)
            }
          }));
    });

    builder.addCase(fetchMapUnitsCounts.fulfilled, (state, { payload }) => {
      state.counts.status = payload.status;
      state.counts.subscription_type = payload.subscription_type;
    })
  }
})

const {
  setMapFilterBy,
  setDrawner,
  resetMapSelectedFilters,
  setMapSelectedFilters,
  updateMapsUnits,
  updateMapLocations,
  setMapSearch,
} = slice.actions

export {
  setMapSearch,
  setMapFilterBy,
  setDrawner,
  resetMapSelectedFilters,
  setMapSelectedFilters,
  fetchMapUnits,
  fetchClientHubs,
  fetchMapDrawerUnits,
  fetchMapUnitsCounts,
  updateMapsUnits,
  updateMapLocations
}

export default slice.reducer
